function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
import styled from "styled-components";
import { GridColumn, GridRow, Footnote } from "../../";
import { TextArea } from "../TextArea";
const Container = styled(GridColumn)`
  width: 100%;
`;
const Counter = styled(GridRow)`
  border: 1px solid ${props => props.theme.palette.gray.primary};
  border-radius: 0 0 4px 4px;
  background-color: #fafafa;
  height: 30px;
  padding: 0 16px;
`;
const TextAreaStyle = styled(TextArea)`
  border-radius: 4px 4px 0 0;
  border-bottom: 0;
`;
export const TextAreaCounter = ({
  charLimit,
  onChange,
  value = "",
  ...props
}) => {
  return /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(TextAreaStyle, _extends({
    onChange: e => onChange(e.target.value),
    value: value,
    maxLength: charLimit
  }, props)), /*#__PURE__*/React.createElement(Counter, {
    xEnd: true,
    yCenter: true
  }, /*#__PURE__*/React.createElement(Footnote, null, value.length, charLimit !== undefined && `/${charLimit}`)));
};